import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import { TypeAsserter } from '@attain-apps/type-guards'

import * as componentStore from '../../component-store'

import * as generalTab from './general-tab'
import * as queryTab from './query-tab'

@ngCore.Component({
  imports: [
    ds.button.Component,
    ds.layout.widget.Component,
    ds.overlay.centered.Component,
    ds.tabs.integratedHorizontal.Component,
    ds.tabs.tab.Directive,
    generalTab.Component,
    queryTab.Component,
  ],
  selector: 'atn-mosaic-page-segment-dialog',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link Store} */
  public readonly store = ngCore.inject(componentStore.builder.Store)

  /** Cancel editing segment button click handler */
  public cancelBtnClickHandler(): void {
    this.store.patchState({
      editingSegmentId: undefined,
    })
  }

  /** Save editing segment button click handler */
  public saveBtnClickHandler(): void {
    this.store.saveEditingSegment()
  }

  /** Delete the segment and close the editor */
  public deleteSegmentBtnClickHandler(): void {
    const editingSegmentId = this.store.editingSegmentIdSg()
    TypeAsserter.assertIsNotNullish(editingSegmentId)
    this.store.deleteSegment(editingSegmentId)
  }
}
